import {FC} from 'react'
import { useWindowSize } from 'react-use';
import { IGlassMargin } from '../../styled-components/Glass.styled';
import { getStyledDotsContainer, getStyledHeroTextContainer } from '../../styled-components/HomeSection.styled';
import { MD_SCREEN } from '../../util/screen-size';
import { Glass } from '../glass/Glass.component'
import { Dots } from '../icons/Dots.component';

export interface HeroSectionProps {
    
}

export const HeroSection: FC<HeroSectionProps> = (props) => {

    const { width } = useWindowSize();
    const size = width > MD_SCREEN

    const mobilGlassMargin: IGlassMargin = {
        top: 0,
        right: 50,
        bottom: 100,
        left: 0
    }

    const pcGlassMargin: IGlassMargin = {
        top: 150,
        right: 0,
        bottom: 0,
        left: 120
    }

    const StyledTextContainer = getStyledHeroTextContainer()
    const StyledDotsContainer = getStyledDotsContainer()

    return(
        <>
            <Glass margin={!size ? mobilGlassMargin : pcGlassMargin}>
                <StyledTextContainer>
                    <span className='title'>We Help You Make Modern Interior</span>
                    <span className='description'>We will help you make an elegant and luxurios interior designed by professional interior desgner.</span>
                </StyledTextContainer>
            </Glass>
            <StyledDotsContainer>
                <Dots color={size ? '#244D4D': '#FEFEFE'} />
            </StyledDotsContainer>
        </>
    )
}